module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Expenses")])], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": _vm.jobDetails.JobId ? _vm.jobDetails.JobId : '',
      "jobSeriesBanner": _vm.jobDetails.JobNo ? _vm.jobDetails.JobNo : '',
      "bannerClientName": _vm.jobDetails.ClientName || _vm.jobDetails.ExpClientName,
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', [_c('b-row', {
    staticClass: "ml-0 mr-0"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h5', [_c('b-badge', {
    staticClass: "ml-2",
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Assignment Details")])], 1), _vm._v(" "), _c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.assignmentData,
      "fields": _vm.assignmentFields,
      "responsive": ""
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Expense Document Details")])], 1), _vm._v(" "), _c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.ExpenseData,
      "fields": _vm.ExpenseDocumentFields,
      "responsive": ""
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row) {
        return [_vm._v("\n                    " + _vm._s(row.index + 1) + "\n                  ")]
      }
    }, {
      key: "approvalStatus",
      fn: function(row3) {
        return [(row3.item.approvalStatus && row3.item.approvalStatus !== '-') ? _c('b-badge', {
          staticStyle: {
            "font-size": "0.75rem",
            "padding": "4px 8px"
          },
          attrs: {
            "variant": _vm.getApprovalStatusVariant(row3.item.approvalStatus)
          }
        }, [_vm._v("\n                      " + _vm._s(row3.item.approvalStatus) + "\n                    ")]) : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("-")])]
      }
    }, {
      key: "documentLink",
      fn: function(row2) {
        return [_c('div', {
          staticClass: "d-flex align-items-center flex-wrap"
        }, [(row2.item.documentLink) ? _c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('a', {
          staticClass: "btn btn-sm btn-outline-primary mr-2",
          attrs: {
            "href": "javascript:void(0)",
            "title": "View Document"
          },
          on: {
            "click": function($event) {
              _vm.openSignedDocument(row2.item.documentLink)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-eye mr-1",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("View\n                        ")]), _vm._v(" "), _c('a', {
          staticClass: "btn btn-sm btn-outline-success mr-2",
          attrs: {
            "href": "javascript:void(0)",
            "title": "Download Document"
          },
          on: {
            "click": function($event) {
              _vm.openSignedDocument(row2.item.documentLink)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download mr-1",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("Download\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.isAdmin && row2.item.ape_id) ? _c('b-button', {
          staticClass: "ml-1",
          attrs: {
            "size": "sm",
            "variant": "outline-danger",
            "pill": "",
            "title": "Remove Document (Admin Only)"
          },
          on: {
            "click": function($event) {
              _vm.removeExpenseDocument(row2.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash mr-1",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("Remove\n    ")]) : _vm._e(), _vm._v(" "), (!row2.item.documentLink && !(_vm.isAdmin && row2.item.ape_id)) ? _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("-")]) : _vm._e()], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-3",
    attrs: {
      "align-v": "start"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('multi-file-uploader', {
    staticClass: "uploader-box",
    attrs: {
      "documentName": 'Expense_Multiple_Doc-',
      "otherDocName": 'Expense_Multiple_Doc-',
      "folderName": 'Expense',
      "accept": '*',
      "assign_no": _vm.jobDetails.JobNo || _vm.$sessionsStorage.get('JOBSERIES'),
      "multiple": true,
      "state": Boolean(_vm.form.singleUpload),
      "fileAllModuleId": _vm.jobDetails.JobId ? String(_vm.jobDetails.JobId) : ''
    },
    model: {
      value: (_vm.form.singleUpload),
      callback: function($$v) {
        _vm.$set(_vm.form, "singleUpload", $$v)
      },
      expression: "form.singleUpload"
    }
  }), _vm._v(" "), (_vm.form.files_err ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.form.files_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nature Of Expense",
      "label-for": "natureSelect",
      "state": !_vm.form.nature_of_expense_err
    }
  }, [_c('model-list-select', {
    attrs: {
      "id": "natureSelect",
      "list": _vm.natureOfExpenseList,
      "option-value": "label",
      "option-text": "label",
      "placeholder": "Select Nature Of Expense"
    },
    on: {
      "input": function($event) {
        _vm.getNatureOfExpenseTitle()
      }
    },
    model: {
      value: (_vm.form.nature_of_expense),
      callback: function($$v) {
        _vm.$set(_vm.form, "nature_of_expense", $$v)
      },
      expression: "form.nature_of_expense"
    }
  }), _vm._v(" "), (_vm.form.nature_of_expense_err) ? _c('b-form-invalid-feedback', [_vm._v("\n                    " + _vm._s(_vm.form.nature_of_expense_err) + "\n                  ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Remark",
      "label-for": "remarkInput",
      "state": !_vm.form.docRemark_err
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "remarkInput",
      "rows": "5",
      "maxlength": 800
    },
    model: {
      value: (_vm.form.docRemark),
      callback: function($$v) {
        _vm.$set(_vm.form, "docRemark", $$v)
      },
      expression: "form.docRemark"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-muted small mt-1"
  }, [_vm._v(_vm._s((_vm.form.docRemark || '').length) + "/800")]), _vm._v(" "), (_vm.form.docRemark_err) ? _c('b-form-invalid-feedback', [_vm._v("\n                    " + _vm._s(_vm.form.docRemark_err) + "\n                  ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "text-right action-footer",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "disabled": !_vm.canSubmit || _vm.jobDetails.JobNo !== _vm.$sessionsStorage.get('JOBSERIES') || _vm.isSubmitting
    },
    on: {
      "click": _vm.adddragfilesINVDetail
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.isSubmitting ? 'Submitting...' : 'Save & Submit') + "\n                ")]), _vm._v(" "), (_vm.isSubmitting) ? _c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  }) : _vm._e()], 1)], 1)], 1)])], 1), _vm._v(" "), (_vm.$sessionsStorage.get('allModuleIdMain')) ? _c('OldExpenseAdditionalTask', {
    attrs: {
      "allModuleId": _vm.$sessionsStorage.get('allModuleIdMain'),
      "type": "expense"
    }
  }) : _vm._e(), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopDelete",
    attrs: {
      "md-content-html": _vm.confirmDelete.content,
      "md-ok-text": _vm.confirmDelete.ok,
      "md-cancel-text": _vm.confirmDelete.cancel
    },
    on: {
      "close": _vm.onCloseDeleteConfirm
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18cb2821","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/ExpensesLite.vue
// module id = 2418
// module chunks = 0